<template>
    <!-- section  -->
    <section class="dark-bg sec-car scroll-con-sec" v-if="videoContent">
        <div class="container">
            <div class="row" v-html="videoContent"></div>
        </div>
    </section>
    <!-- section end-->
</template>

<script>
export default {
    name: 'HomeVideoSection',
    data() {
        return {
            videoContent: ''
        }
    },
    async mounted() {
        await this.loadVideoContent()
        
        // Initialize video players after content is loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.initVideoPlayers()
            }, 100)
        })
    },
    beforeUnmount() {
        // Clean up video players if needed
        const $ = window.jQuery
        if ($) {
            $('.background-youtube-wrapper').each(function() {
                const player = $(this).data('ytPlayer')
                if (player && player.player && typeof player.player.destroy === 'function') {
                    player.player.destroy()
                }
            })
        }
    },
    methods: {
        async loadVideoContent() {
            try {
                const response = await this.$api.get('public/content/video')
                if (response.data && response.data.data && response.data.data.length > 0) {
                    this.videoContent = response.data.data[0].content
                    console.log('✅ Loaded video content')
                }
            } catch (error) {
                console.error('❌ Failed to load video content:', error)
            }
        },
        
        initVideoPlayers() {
            const $ = window.jQuery
            
            if (!$ || !$(".video-holder-wrap").length) {
                return
            }
            
            console.log('🎬 Initializing video players...')
            
            // YouTube video initialization
            if ($(".background-youtube-wrapper").length > 0) {
                const videoId = $(".background-youtube-wrapper").data("vid")
                const mute = $(".background-youtube-wrapper").data("mv")
                
                if ($.fn.YTPlayer) {
                    $(".background-youtube-wrapper").YTPlayer({
                        fitToBackground: true,
                        videoId: videoId,
                        pauseOnScroll: true,
                        mute: mute,
                        callback: function () {
                            // Player ready
                        }
                    })
                }
            }
            
            // Vimeo video initialization
            if ($(".background-vimeo").length > 0) {
                const vimeoId = $(".background-vimeo").data("vim")
                const bvc = $(".background-vimeo")
                const bvmc = $(".media-container")
                const vch = $(".video-container")
                
                bvc.append('<iframe src="//player.vimeo.com/video/' + vimeoId + '?background=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
                
                $(".video-holder").height(bvmc.height())
                
                const bvfc = $(".background-vimeo iframe")
                
                if ($(window).width() > 1024) {
                    if ($(".video-holder").length > 0) {
                        if (bvmc.height() / 9 * 16 > bvmc.width()) {
                            bvfc.height(bvmc.height()).width(bvmc.height() / 9 * 16)
                            bvfc.css({
                                "margin-left": -1 * bvfc.width() / 2 + "px",
                                top: "-75px",
                                "margin-top": "0px"
                            })
                        } else {
                            bvfc.width($(window).width()).height($(window).width() / 16 * 9)
                            bvfc.css({
                                "margin-left": -1 * bvfc.width() / 2 + "px",
                                "margin-top": -1 * bvfc.height() / 2 + "px",
                                top: "50%"
                            })
                        }
                    }
                } else if ($(window).width() < 760) {
                    $(".video-holder").height(bvmc.height())
                    bvfc.height(bvmc.height())
                } else {
                    $(".video-holder").height(bvmc.height())
                    bvfc.height(bvmc.height())
                }
                
                vch.css("width", $(window).width() + "px")
                vch.css("height", Number(720 / 1280 * $(window).width()) + "px")
                
                if (vch.height() < $(window).height()) {
                    vch.css("height", $(window).height() + "px")
                    vch.css("width", Number(1280 / 720 * $(window).height()) + "px")
                }
            }
            
            console.log('✅ Video players initialized')
        }
    }
}
</script>

